import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.NfsSubscription')
export class NfsSubscription extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'email')
  email?: string;

  @JsonProperty(String, 'roleName')
  roleName?: string;

  @JsonProperty(Boolean, 'sendEmail')
  sendEmail?: boolean;

  @JsonProperty(Boolean, 'sendSMS')
  sendSMS?: boolean;

  @JsonProperty(Boolean, 'showInSystem')
  showInSystem?: boolean = true;

  @JsonProperty(String, 'type')
  type?: string;

  @JsonProperty(User, 'user')
  user?: User;
}
